import React, { useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate, useParams } from 'react-router-dom';


const SearchUser = ({ token ,onClose }) => {
    // const [searchType, setSearchType] = useState('userId'); // 검색 타입: userId 또는 googleId
    const [searchValue, setSearchValue] = useState(''); // 검색 값
    const [users, setUsers] = useState([]); // 검색된 사용자 데이터
    const [error, setError] = useState(null); // 에러 메시지
    const navigate = useNavigate();

    const handleSearch = async () => {
        try {
            setError(null); // 에러 초기화
            setUsers([]); // 사용자 초기화

            const response = await axios.get(`/users/search`, {
                params: { searchValue },
                headers: { Authorization: `Bearer ${token}` },
            });

            setUsers(response.data.users); // 사용자 데이터 설정
        } catch (err) {
            setError(err.response?.data?.message || 'Error searching user');
        }
    };

    return (
        <div className="search-user">
            <h3 className="search-user-title">사용자 검색</h3>

            <div className="search-user-controls">
                {/* <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    className="search-user-select"
                >
                    <option value="userId">User ID</option>
                    <option value="googleId">Google ID</option>
                </select> */}

                <input
                    type="text"
                    // placeholder={searchType === 'userId' ? 'Enter User ID' : 'Enter Google ID'}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    className="search-user-input"
                />

                <button onClick={handleSearch} className="search-user-button">
                    검색
                </button>
            </div>

            {error && <p className="search-user-error">{error}</p>}

            {users.lenght != 0 && (
                <ul className="Randomboard-list">
                {users.map((user) => (
                    <li key={user.username} className="Randomboard-item">
                    <div className="Randomboard-user">
                        <img
                        src={`/assets/character/${user.avatar}`}
                        alt="Avatar"
                        className="Randomboard-avatar"
                        />
                        <div className="Randomboard-info">
                        <p className="Randomboard-username">{user.username}</p>
                        </div>
                    </div>
                    <button
                        className="Randomboard-button"
                        // onClick={() => navigate(`/userSun/${user.uuid}`)}
                        onClick={() => {
                            navigate(`/userSun/${user.uuid}`)
                            onClose()
                          }}
                    >
                        해 보러가기
                    </button>
                    </li>
                ))}
                </ul>
            )}
        </div>
    );
};

export default SearchUser;